module.exports = __webpack_public_path__ + "media/images/code_2-8e2cb5fc6fdd0c6aa649dfd905d56261.png";